import { createElement, useCallback } from 'react';
import { ghostButtonLabelStyles } from '@ui/ghost-button.styles';
import { ConfirmOptions, confirm } from 'material-ui-confirm';
import { TouchRippleProps } from '@mui/material';

export const useIsConfirmed = (): ((
  options?: ConfirmOptions | string,
) => Promise<boolean>) => {
  return useCallback(async (options) => {
    const formattedOptions = toConfirmOptions(options);
    const cancelProps = formattedOptions?.cancellationButtonProps;
    const confirmProps = formattedOptions?.confirmationButtonProps;

    const { confirmed } = await confirm({
      ...formattedOptions,
      cancellationText: createElement(
        'span',
        { style: ghostButtonLabelStyles },
        formattedOptions?.cancellationText ?? 'Cancel',
      ),
      confirmationText: createElement(
        'span',
        { style: ghostButtonLabelStyles },
        formattedOptions?.confirmationText ?? 'Ok',
      ),
      cancellationButtonProps: {
        TouchRippleProps: touchRippleProps,
        ...cancelProps,
      },
      confirmationButtonProps: {
        variant: 'contained',
        autoFocus: true,
        TouchRippleProps: touchRippleProps,
        ...confirmProps,
      },
      dialogProps: { closeAfterTransition: false },
    });
    return confirmed;
  }, []);
};

const toConfirmOptions = (
  options?: ConfirmOptions | string,
): ConfirmOptions | undefined =>
  typeof options === 'string' ? { description: options } : options;

const touchRippleProps: TouchRippleProps = {
  style: { top: 'auto', bottom: 0, height: 4 },
};
